import React, {useState} from "react";
import { Select, Input } from 'antd'
import {generateYearOptions} from "../../composable/useDates";

import './styles/season-card-content.scss'

const { TextArea } = Input;

interface Props {
    remove: (index:number) => void;
    index: number
}

function SeasonCardContent({remove, index}: Props) {
    const [sort, setSort] = useState(0)
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [year, setYear] = useState<string>('')

    const onRemove = () => {
        remove(index)
    }

    return (
        <section className="season-card-content">
            <div className="form-group">
                <label className="form-group__label">Название *</label>
                <Input
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Название"
                />
            </div>

            <div className="season-card-content__grid">
                <div className="form-group">
                    <label className="form-group__label">Описание *</label>
                    <TextArea
                        className={"app-textarea season-card-content__description"}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        rows={4}
                        placeholder="Описание"
                    />
                </div>

                <div className="form-group">
                    <label className="form-group__label" htmlFor={"Year"}>Год выпуска *</label>
                    <Select
                        id={"Year"}
                        className={"app-select"}
                        value={year}
                        onChange={(val) => setYear(val)}
                        placeholder="Выберите год"
                        options={generateYearOptions()}
                        style={{ width: 300 }}
                        allowClear
                    />
                </div>
            </div>

            <div className="form-group season-card-content__sort">
                <label className="form-group__label">Сортировка *</label>
                <Input
                    value={sort}
                    onChange={(e) => setSort(e.target.value)}
                    placeholder="Сортировка"
                />
            </div>

            <div className="season-card-content__footer">
                <button className="season-card-content__remove" onClick={onRemove}>Удалить</button>
            </div>
        </section>
    )
}

export default SeasonCardContent